import { logoActions } from './logoSlice'
import { fetchHelper } from '../../../api/api'
import { userActions, userSelectors } from '../../../redux/userSlice'

export const uploadLogo = ({ email, file }) => async dispatch => {
    dispatch(logoActions.uploadLogoRequest())
    try {
        const formData = new FormData()
        formData.append('file', file)
        const response = await fetchHelper.post(
            `Customer/UploadCompanyLogo/${email}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        )
        dispatch(
            userActions.updateDetails({ userDetails: { logo: response.data } })
        )
        dispatch(logoActions.uploadLogoRequestSuccess())
    } catch (e) {
        dispatch(logoActions.uploadLogoRequestError(e.message))
    }
}
